<template>
  <div class="invite-page-wrap">
    <div class="invite-top">
      <div class="invite-btn" @click="openShare">立即邀請賺佣金</div>
      <div class="invite-side">
        <div class="opacity-wrap">
        </div>
        <div class="invited-btn" @click="openInvitedSide">
          <p>我的好頭家</p>
          <img :class="direction === -1 ? 'rotate-img': null" src="~@/assets/images/top-point.png" alt="">
        </div>
        <div class="my-invited">
          <div class="invited-header">
            <div class="invited-header-left">
              <p>已成功邀請 {{invitedList.length}}人
              <el-popover
                placement="bottom-start"
                width="187px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">完成有效下單的用戶進入已激活狀態</p>
                </div>
                <img slot="reference" class="invited-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="187px"
                trigger="click">
                <div>
                  <p class="rules-title order-rules-dialog-normal">完成有效下單的用戶進入已激活狀態</p>
                </div>
                <img slot="reference" class="invited-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              </p>
            </div>
            <fps-icon class="close-simple" type="close" @click.native="openInvitedSide" />
          </div>
          <div class="invited-content">
            <div class="invited-item" v-for="(item, index) in invitedList" :key="index">
              <div class="invited-left">
                <img :src="item.avatarUrl" alt="">
                <div class="invited-msg">
                  <p>{{ item.nickname }}</p>
                  <p>{{ new Date(item.createTime).$format('yyyy-MM-dd') }}</p>
                </div>
              </div>
              <div class="invited-right">
                <p :class="item.becomeOrderBoy === 'Notyet' ? null : 'order-boy'">{{item.becomeOrderBoy === 'Notyet' ? '已註冊' : '已激活'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="invite-bottom">
      <img class="image-text-1" src="./images/text-image-1.png">
      <img class="image-text-2" src="./images/text-image-2.png">
      <div class="invite-btn top-btn" @click="openShare(1)">立即邀請賺佣金</div>
      <div class="my-reward" v-if="inviterInfo.personNum !== 0">
        <div class="myreward-header">我的獎勵
          <div class="myreward-header-right myreward-header-right-normal" @click="toWithDraw">
            <p>去 [我的錢包] 提現</p>
            <img src="~@/assets/images/to-mywallet.png" alt="">
          </div>
          <div class="myreward-header-right myreward-header-right-auto" @click="toWithDrawAuto">
            <p>去 [我的錢包] 提現</p>
            <img src="~@/assets/images/to-mywallet.png" alt="">
          </div>
        </div>
        <div class="myreward-content">
          <div class="myreward-content-wrap myreward-content-invited">
            <span>
              <span>{{inviterInfo.personNum}}</span>
              <span>人</span>
            </span>
            <span>已成功邀請</span>
          </div>
          <div class="myreward-content-line"></div>
          <div class="myreward-content-wrap myreward-content-order">
            <span>
              <span>{{inviterInfo.orderNum}}</span>
              <span>單</span>
            </span>
            <span>完成有效訂單
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">有效訂單：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 非使用新人優惠券的訂單</p>
                    <p>2. 訂單需進入最終完成狀態後，對應獎勵才會發放</p>
                  </div>
                </div>
                <img slot="reference" class="rules-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="click">
                <div>
                  <p class="rules-title order-rules-dialog-normal">有效訂單：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 非使用新人優惠券的訂單</p>
                    <p>2. 訂單需進入最終完成狀態後，對應獎勵才會發放</p>
                  </div>
                </div>
                <img slot="reference" class="rules-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
            </span>
          </div>
          <div class="myreward-content-line"></div>
          <div class="myreward-content-wrap myreward-content-count">
              <span>${{inviterInfo.totalEarnMoney ? inviterInfo.totalEarnMoney : 0}}</span>
              <span>累計收益</span>
          </div>
        </div>
      </div>
      <div class="base-reward">
        <div class="base-reward-top">
          <p>如何獲得獎勵</p>
          <p @click="openRules">活動規則</p>
        </div>
        <div class="base-reward-bottom">
          <div class="base-reward-step base-reward-1">
            <img src="~@/assets/images/invite-share.png" alt="">
            <p>分享</p>
            <p>邀請鏈接</p>
          </div>
          <div class="base-reward-point">
            <img src="~@/assets/images/invite-right-point.png" alt="">
          </div>
          <div class="base-reward-step base-reward-2">
            <img src="~@/assets/images/invite-login.png" alt="">
            <p>用戶</p>
            <p>成功註冊</p>
          </div>
          <div class="base-reward-point">
            <img src="~@/assets/images/invite-right-point.png" alt="">
          </div>
          <div class="base-reward-step base-reward-3">
            <img src="~@/assets/images/invite-order.png" alt="">
            <p>獲得</p>
            <p>佣金抽成</p>
          </div>
        </div>
        <div class="more-reward-top">
          <p>佣金抽成</p>
          <div class="more-reward-content">
            <p>獲得該用戶後續10個訂單的佣金抽成
              <el-popover
                placement="bottom-start"
                width="299px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">佣金抽成：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 用戶成功註冊后，後續前10個訂單都可獲得佣金抽成獎勵</p>
                    <p>2. 用戶對平台上任何陪陪下單，推薦人都會收到抽成獎勵</p>
                    <p>3. 使用新人優惠券的訂單不抽成，不計為有效下單</p>
                  </div>
                </div>
                <img slot="reference" class="reward-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="299px"
                trigger="click">
                <div class="reward-text">
                  <p class="rules-title order-rules-dialog-normal">佣金抽成：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 用戶成功註冊后，後續前10個訂單都可獲得佣金抽成獎勵</p>
                    <p>2. 用戶對平台上任何陪陪下單，推薦人都會收到抽成獎勵</p>
                    <p>3. 使用新人優惠券的訂單不抽成，不計為有效下單</p>
                  </div>
                </div>
                <img slot="reference" class="reward-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
            </p> 
      
          </div>
        </div>
        <div class="more-reward-bottom">
          <div class="percent-step percent-1">
            <div class="step-wrap">
              <img :class="currentStep === 1 ? 'current-step' : currentStep < 1 ? 'opacity-step' : null" src="~@/assets/images/perecent5.png" alt="">
            </div>
            <p>1-20人</p>
          </div>
          <img :class="currentStep < 1 ? 'opacity-step' : null" class="point-right point-right-1" src="~@/assets/images/perecent-right.png" />
          <div class="percent-step percent-2">
            <div class="step-wrap">
              <img :class="currentStep === 2 ? 'current-step' : currentStep < 2 ? 'opacity-step' : null" src="~@/assets/images/perecent6.png" alt="">
            </div>
            <p>21-50人</p>
          </div>
          <img :class="currentStep < 2 ? 'opacity-step' : null"  class="point-right point-right-2" src="~@/assets/images/perecent-right.png" />
          <div class="percent-step percent-3">
            <div class="step-wrap">
              <img :class="currentStep === 3 ? 'current-step' :currentStep < 3 ? 'opacity-step' : null" src="~@/assets/images/perecent7.png" alt="">
            </div>
            <p>51+人</p>
          </div>
        </div>
        <div class="ex-reward-wrap">
          <p>用户儲值獎勵</p>
          <div>
            <p>用户首次成功儲值你就賺 
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">用户首次儲值：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 儲值1000-2000 邀請人獲得 $50 </p>
                    <p>2. 儲值2001-3000 邀請人獲得 $100</p>
                    <p>3. 儲值3001-4000 邀請人獲得 $150</p>
                    <p>4. 儲值4001-5000 邀請人獲得 $200</p>
                    <p>5. 儲值5000以上 邀請人獲得 $250</p>
                  </div>
                </div>
                <img slot="reference" class="rules-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="click">
                <div>
                  <p class="rules-title order-rules-dialog-normal">用户首次儲值：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 儲值1000-2000 邀請人獲得 $50 </p>
                    <p>2. 儲值2001-3000 邀請人獲得 $100</p>
                    <p>3. 儲值3001-4000 邀請人獲得 $150</p>
                    <p>4. 儲值4001-5000 邀請人獲得 $200</p>
                    <p>5. 儲值5000以上 邀請人獲得 $250</p>
                  </div>
                </div>
                <img slot="reference" class="rules-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
            </p>
          </div>
          <img class="ex-reward" src="~@/assets/images/250redbag.png" alt="">
        </div>
        <div class="success-invite">
          <p>成功邀請用户獎勵</p>
          <div class="success-invite-middle">
            <p>隨機抽取$10-$500獎勵金
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">獎勵說明：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 首次成功邀請用戶完成註冊，您可獲得$10-$500隨機獎勵金！</p>
                    <p>2. 每成功邀請5位用户，您可獲得$10-$500隨機獎勵金 </p>
                    <p>3. 每日最多抽獎4次，超過後當日不再抽獎，後續不給與補抽機會 </p>
                  </div>
                </div>
                <img slot="reference" class="rules-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="160px"
                trigger="click">
                <div class="invited-rules-text">
                  <p class="rules-title order-rules-dialog-normal">獎勵說明：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 首次成功邀請用戶完成註冊，您可獲得$10-$500隨機獎勵金！</p>
                    <p>2. 每成功邀請5位用户，您可獲得$10-$500隨機獎勵金 </p>
                    <p>3. 每日最多抽獎4次，超過後當日不再抽獎，後續不給與補抽機會 </p>
                  </div>
                </div>
                <img slot="reference" class="rules-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
            </p>
          </div>
          <div class="success-invite-bottom">
            <div>
              <img src="~@/assets/images/invited-first.png" alt="">
              <p>首次成功邀請</p>
            </div>
            <div>
              <img src="~@/assets/images/invited-five.png" alt="">
              <p>每成功邀請5位</p>
            </div>
          </div>
        </div>
      </div>
      <div class="my-reward" v-if="inviterInfo.personNum === 0">
        <div class="myreward-header">我的獎勵
          <div class="myreward-header-right myreward-header-right-normal" @click="toWithDraw">
            <p>去 [我的錢包] 提現</p>
            <img src="~@/assets/images/to-mywallet.png" alt="">
          </div>
          <div class="myreward-header-right myreward-header-right-auto" @click="toWithDrawAuto">
            <p>去 [我的錢包] 提現</p>
            <img src="~@/assets/images/to-mywallet.png" alt="">
          </div>
        </div>
        <div class="myreward-content">
          <div class="myreward-content-wrap myreward-content-invited">
            <span>
              <span>{{inviterInfo.personNum}}</span>
              <span>人</span>
            </span>
            <span>已成功邀請</span>
          </div>
          <div class="myreward-content-line"></div>
          <div class="myreward-content-wrap myreward-content-order">
            <span>
              <span>{{inviterInfo.orderNum}}</span>
              <span>單</span>
            </span>
            <span>完成有效訂單
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="hover">
                <div>
                  <p class="rules-title order-rules-dialog-normal">有效訂單：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 非使用新人優惠券的訂單</p>
                    <p>2. 訂單需進入最終完成狀態後，對應獎勵才會發放</p>
                  </div>
                </div>
                <img slot="reference" class="rules-web" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
              <el-popover
                placement="bottom-start"
                width="190px"
                trigger="click">
                <div>
                  <p class="rules-title order-rules-dialog-normal">有效訂單：</p>
                  <div class="rules-detail order-rules-dialog-normal">
                    <p>1. 非使用新人優惠券的訂單</p>
                    <p>2. 訂單需進入最終完成狀態後，對應獎勵才會發放</p>
                  </div>
                </div>
                <img slot="reference" class="rules-auto" src="~@/assets/images/invite-question.png" alt="">
              </el-popover>
            </span>
          </div>
          <div class="myreward-content-line"></div>
          <div class="myreward-content-wrap myreward-content-count">
              <span>${{inviterInfo.totalEarnMoney ? inviterInfo.totalEarnMoney : 0}}</span>
              <span>累計獲得</span>
          </div>
        </div>
      </div>
      <div class="receive-invite">
        <div class="receive-invite-top">
          <div class="receive-invite-header">
            <img src="~@/assets/images/bottom-ear.png" alt="">
            <p>接受邀請 好友可獲得</p>
            <img src="~@/assets/images/bottom-ear.png" alt="">
          </div>
          <div class="receive-invite-img">
            <img src="~@/assets/images/invite-friend.png" alt="">
          </div>
        </div>
        <div class="receive-invite-bottom">
          <p>用户完成首次體驗後獲得1張專屬優惠券</p>
          <img src="~@/assets/images/gold-reward.png" alt="">
        </div>
      </div>
      <div class="invite-rule">
        <div class="auto-invite-btn" @click="openShare(2)">立即邀請賺佣金</div>
        <div class="invite-btn" @click="openShare(2)">立即邀請賺佣金</div>
        <p @click="openRules">活動規則</p>
      </div>
    </div>
    <el-dialog
      :visible.sync="shareDialog"
      :show-close="true"
      append-to-body
      width="335px"
      custom-class="invite-share-dialog">
      <div class="share-avatar">
        <img :src="userInfo.avatarUrl" alt="">
      </div>
      <div class="share-title">分享您的專屬鏈接</div>
      <div class="share-url">
        <p class="share-url-text">https://3uplay.com/player-detail/ref{{inviterInfo.unique}}</p>
        <p class="share-url-btn" @click="copyUrl">複製鏈接</p>
      </div>
      <div class="share-text">
        <p>邀請小技巧</p>
        <div>
          <span class="gray-point"></span>
          <p>將鏈接放到自己的社交媒體上，如 Facebook / Instagram / Twitch 等平台成功率最高 </p>
        </div>
        <div>
          <span class="gray-point"></span>
          <p>分享至3個以上 Line 及 Discord 群，成功邀請的機率提升200% </p>
        </div>
        <div>
          <span class="gray-point"></span>
          <p>轉發到各種遊戲社群論壇PTT等 </p>
        </div>
      </div>
      <div class="close-btn" @click="closeDialog">
        <fps-icon class="close-icon" type="close" />
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="rulesDialog"
      :show-close="false"
      append-to-body
      width="335px"
      custom-class="invite-rules-dialog">
      <p class="rules-title">活動規則</p>
      <div class="rules-detail">
        <p class="bottom-title">詳細規則</p>
        <p>每個用戶通過您分享的鏈接，您可獲得用戶後續前10個有效訂單的5%～7%佣金抽成。（包括用户對平台任何人的下單）</p>     
        <p>首次成功邀請用戶完成註冊，您可獲得$10-$500隨機獎勵金！</p> 
        <p>後續每邀請5個用戶完成註冊，還可以獲得$10-$500隨機獎勵金！（每日最多發放4次隨機獎勵金）</p> 
        <p>有效訂單：非使用新人優惠券的訂單；訂單需進入最終完成狀態後，3日內對應獎勵會發放至錢包。</p> 
        <p>本次活動僅適用於註冊手機號為台灣，其他地區用戶不開放參與。</p> 
        <p class="bottom-title attention-title">注意事項</p>
        <p>為保證所有用戶的收益不被影響，存在非正常邀請行為的用戶，平台將取消其參加活動的資格，並扣除其所有活動獎勵所得。 </p> 
        <p>本活動為限時活動，活動結束日期之後完成下單的用戶，不再發放佣金抽成
        <p>對於活動中存在異常下單行為的用戶，需退還全部不當所得金額並賠償30%，nicee平台官方判定存在問題的用戶，有權凍結問題用戶的帳戶並做進一步查證。</p>
        <p>多個帳戶在同一設備登陸，同一設備上的多個帳號將被視為違約，nicee有權取消違規帳號的活動參與和獎勵金。</p>
        <p>nicee平台擁有活動規則最終解釋權，可以根據本活動的實際情況對活動規則進行變動或調整，相關變動或調整將公布在活動頁面上，並於公布時即時生效。</p>  
      </div>
      <div class="close-btn" @click="closeDialog">
        <fps-icon class="close-icon" type="close" />
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { setToken } from '@/utils/auth'
export default {
  data () {
    return {
      shareDialog: false,
      rulesDialog: false,
      inviterInfo: {
        personNum: 0,
        orderNum: 0,
        totalEarnMoney: 0,
        unique: '',
      },
      direction:1,
      invitedList: [],
      pageIndex: 0,
      pageSize: 20,
    }
  },  
  computed: { 
    ...mapGetters(['userInfo']),

    currentStep () {
      if(this.inviterInfo.personNum === 0) return 0
      else if(this.inviterInfo.personNum > 0 && this.inviterInfo.personNum < 21) return 1
      else if(this.inviterInfo.personNum > 20 && this.inviterInfo.personNum < 51) return 2
      else return 3
    }
  },
  created () {
    this.getInviterInfo()
  },
  mounted() {
    let header = document.getElementsByClassName('page-header')[0]
    let footer = document.getElementsByClassName('page-footer')[0]
    if(this.$route.query.token) {
      header.style.display= 'none'
      footer.style.display= 'none'
    }
    this.$adjust('app_referral_entry', {})
  },
  methods: {
    openInvitedSide() {
      const scroller = document.querySelector('.invite-side')
      if (scroller) {
        // const scrollLeft = scroller.scrollLeft
        scroller.scrollTo({
          left: 400 * this.direction,
          behavior: 'smooth'
        })
      }
      this.direction = this.direction * -1
    },
    getInviterInfo() {
      this.$http.get('/inviterB/info').then((data)=>{
        this.inviterInfo = data.data
        try {
          window.localStorage.getItem('STORAGE_INVITER_UUID', this.userInfo.uuid)
        } catch(e) {
          console.log(e)
        }
      })
      this.$http.post('/inviterB/list', {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }).then((data)=> {
        this.invitedList = data.data
      })
    },

    openShare(type) {
      this.shareDialog = true
      this.$adjust('app_referral_share', {
        type,
      })
    },
    openRules() {
      this.rulesDialog = true
    },
    toWithDraw() {
      this.$router.push({
        name: 'UserAccount'
      })
    },
    toWithDrawAuto() {
      this.$message.error("提現功能請到網頁版中使用")
    },
    copyUrl() {
      let input = document.createElement("input");
      input.value = 'https://3uplay.com/player-detail/ref' + this.inviterInfo.unique ;
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, input.value.length), document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message({
        type: 'success',
        message: '已複製'
      })
      this.$adjust('app_referral_share_link', {})
    },
    closeDialog() {
      this.rulesDialog = false
      this.shareDialog = false
    }
  },

}
</script>
<style lang="scss">
  .invite-share-dialog {
    border-radius: 15px;
    .el-dialog__header {
      display: none
    }
    .el-dialog__body {
      padding-top: 70px;
    }
  }
  .invite-rules-dialog {
    border-radius: 15px;
    .el-dialog__header {
      display: none
    }
  }
  .order-rules-dialog {
    border-radius: 15px;
    .el-dialog__header {
      display: none
    }
  }
  .reward-text {
    width: 299px;
  }
  .invited-rules-text {
    width:299px;
  }
  @media screen and (max-width: 599px) {
    .invite-rules-dialog {
      margin-top: 8vh !important;
    }
  }
</style>
<style lang="scss" scoped>
  .invite-page-wrap {
    background: #627CFF;
    .rules-auto {
      display: none !important;
    }
    .invite-top {
      width: 100%;
      height: 70px;
      background-size:100% 544px;
      position: relative;
      .invite-side {
        position: absolute;
        right: 0px;
        flex-shrink: 0;
        top: 53px;
        width: 405px;
        height: 518px;
        padding-top: 10px;
        padding-bottom: 20px;
        padding-left: 20px;
        overflow-x: auto;
        display: flex;
        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }
        .opacity-wrap {
          width: 360px;
          height: 488px;
          flex-shrink: 0;

          background: none;
        }
       .invited-btn {
          cursor: pointer;
          text-align: center;
          width: 25px;
          height: 105px;
          background: #F554AB;
          box-shadow: -5px 2px 10px rgba(0, 0, 0, 0.15);
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 1px;
          flex-shrink: 0;
          padding: 10px 0;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          line-height: 14px;
          text-align: center;
          color: #FFFFFF;
          img {
            width: 14px;
            height: 11px;
            margin-top: 5px;
          }
          .rotate-img {
            transform:rotate(180deg);
          }

        }
        .my-invited {
          width: 359px;
          height: 488px;
          flex-shrink: 0;
          z-index: 1;
          background: white;
          border-bottom-left-radius: 6px;
          padding: 0 18px;
          box-shadow: -10px 4px 20px rgba(0, 0, 0, 0.1);
          .invited-header {
            height: 43px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-style: normal;
            align-items: center;
            font-weight: normal;
            font-size: 12px;
            line-height: 43px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            color: #9199A9;
            .invited-header-left {
              display: flex;
              align-items: center;
              img {
                position: relative;
                top: 1px;
                cursor: pointer;
              }
              .invited-auto {
                display: none;
              }
            }
            img {
              width: 24px;
              height: 24px;
              margin-left: 4px;
            }
            .close-simple {
              font-size: 18px;
              color: $color-gray-1;
              cursor: pointer;
            }
          }
          .invited-content {
            height: 430px;
            width: 100%;
            overflow-y: auto;        
            &::-webkit-scrollbar {
                display: none;
                width: 0;
                height: 0;
              }
            .invited-item {
              width: 100%;
              height: 33px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 18px;
              .invited-left {
                display: flex;
                img {
                  width: 33px;
                  height: 33px;
                  border-radius: 100%;
                }
                .invited-msg {
                  display: flex;
                  flex-direction: column;
                  margin-left: 10px;
                  justify-content: space-between;
                  p {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 14px;
                    display: flex;
                    align-items: center;
                    color: #333333;
                  }
                  p:last-child {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 12px;
                    line-height: 12px;
                    letter-spacing: -0.000230973px;
                    color: #999999;
                  }
                }
              }
              .invited-right {
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 33px;
                display: flex;
                align-items: center;
                color: #333333;
                .order-boy {
                  font-weight: 600;
                  color: #38BA7C;
                }
              }

            }
          }
        }
      }
    }
    .invite-bottom {
      width: 872px;
      margin: 0 auto;
      padding-bottom: 256px;
      &>div {
        background: white;
        border-radius: 6px;
        display: flex;
        margin: 0 auto;
        margin-top: 16px;
        flex-direction: column;
      }
      .image-text-1 {
        display: block;
        width: 354px;
        margin-bottom: 12px;
      }
      .image-text-2 {
        display: block;
        width: 219px;
        margin-bottom: 31px;
      }
      .invite-btn {
        width: 226px;
        height: 64px;
        background: #FDF300;
        border: 4px solid #0156FB;
        box-sizing: border-box;
        border-radius: 32px;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 58px;
        text-align: center;
        color: #0156FB;
        cursor: pointer;
      }
      .top-btn {
        transform: translateX(-323px);
        margin-bottom: 45px;
      }
      .my-reward {
        height: 143px;
        .myreward-header {
          height: 45px;
          background: #EEF1FF;
          text-align: left;
          padding-left: 20px;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          line-height: 45px;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          color: #000831;
          .myreward-header-right {
            display: inline-block;
            height: 45px;
            font-style: normal;
            font-weight: normal;
            position: absolute;
            right: 10px;
            font-size: 12px;
            text-align: right;
            color: #4957A0;
            cursor: pointer;
            p {
              display: inline-block;
            }
            img {
              display: inline-block;
              width: 11px;
              position: relative;
              top: 1px;
              height: 11px;
            }
          }
          .myreward-header-right-auto {
            display: none;
          }
        }
        .myreward-content {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 98px;
          >div {
            display: flex;
            align-items: center;
            flex-direction: column;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 17px;
            color: #000831;
            span:first-child {
              font-style: normal;
              font-weight: 600;
              font-size: 18px;
              line-height: 17px;
              color: #FF5A62;
              span:last-child {
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 17px;
              }
            }
         
          }
          .myreward-content-line {
            width: 4px;
            height: 36px;
            background: #EEF1FF;
            border-radius: 100px;
          }
          .myreward-content-invited {
            margin-right: 60px;
          }
          .myreward-content-count {
            margin-left: 60px;
            span:first-child{
              margin-bottom: 5px;
            }
          }
          .myreward-content-order {
            width: 156px;
            img {
              width: 14px;
              height: 14px;
              position: relative;
              top: 6px;
              cursor: pointer;
            }
          }
        }
      }
      .base-reward {
        height: 765px;
        .base-reward-top {
          height: 45px;
          line-height: 45px;
          text-align: center;
          display: flex;
          margin-bottom: 25px;
          padding:0 20px;
          justify-content: space-between;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          color: #000831;
          background: #EEF1FF;
          p:last-child {
            font-style: normal;
            font-weight: normal;
            cursor: pointer;
            font-size: 14px;
            line-height: 45px;
            text-align: center;
            color: #4957A0;
          }
        }
        .base-reward-bottom {
          height: 104px;
          display: flex;
          justify-content: center;
          widows: 100%;
          padding-bottom: 30px;
          border-bottom: 1PX solid #EEF1FF;
          >div {
            height: 74px;
            width: 36px;
            margin: 0 25px;  
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
          }
          .base-reward-step {
            img {
              width: 36px;
              height: 36px;
              margin-bottom: 4px;
            }
            p {
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              width: 72px;
              line-height: 17px;
              text-align: center;
              color: #2F323F;
              white-space:nowrap;
            }
          }
          .base-reward-point {
            img {
              width: 18px;
              height: 18px;
              margin-top: 9px;
            }
          }
        }
        .more-reward-top {
          width: 100%;
          height: 98px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          p {
            width: 100%;
            text-align: center;
            height: 22px;
            line-height: 22px;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            text-align: center;
            color: #000831;
          }
          .more-reward-content {
            display: flex;
            p {
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 17px;
              text-align: center;
              color: #9199A9;
              margin-top: 10px;
            }
            img {
              width: 24px;
              height: 24px;
              position: relative;
              top: 6px;
              cursor: pointer;
            }
            .reward-auto {
              display: none;
            }
          }
        }
        .more-reward-bottom {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding-bottom: 25px;
          border-bottom: 1px solid #EEF1FF;
          .opacity-step {
            opacity: 0.3;
          }
          .percent-step {
            img {
              width: 53px;
              height: 36px;
            }
            .step-wrap {
              height: 42px;
              display: flex;
              align-items: flex-end;
              margin-bottom: 7px;
            }
            .current-step {
              width: 63px;
              height: 42px;
            }
            p {
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 17px;
              text-align: center;
              color: #2F323F;
            }
          }
          .point-right {
            width: 18px;
            height: 18px;
            margin: 15px 44px 0 44px;
          }
        }
        .ex-reward-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          border-bottom: 1px solid #EEF1FF;
          p {
            font-style: normal;
            margin: 20px 0 10px 0;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            color: #000831;
          }
          div p{
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            color: #9199A9;
            margin: 0 0 30px 0;
            img {
              width: 24px;
              height: 24px;
              position: relative;
              top: 6px;
              cursor: pointer;
            }
          }
          .ex-reward {
            width: 122px;
            height: 88px;
            margin-bottom: 25px;
          }

        }
        .success-invite {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 25px;
          p {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #000831;
            margin-bottom: 6px;
          }
          .success-invite-middle {
            p {
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 17px;
              text-align: center;
              color: #9199A9;
            }
            img {
              width: 24px;
              height: 24px;
              position: relative;
              top: 6px;
              cursor: pointer;
            }
          }
          .success-invite-bottom {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 20px;
            div {
              display: flex;
              flex-direction: column;
              align-items: center;
              &:first-child {
                margin-right: 71px;
              }
              img {
                width: 40px;
                height: 36px;
              }
              p {
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 17px;
                text-align: center;
                color: #2F323F;
              }
            }
          }
        }
      }
      .receive-invite {
        height: 412px;
        .receive-invite-top {
          border-bottom: 1px solid #EEF1FF;
          padding-bottom: 25px;
        }
        .receive-invite-bottom {
          display: flex;
          flex-direction: column;
          align-items: center;
          p {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            color: #9199A9;
            margin: 25px 0;
          }
          img {
            width: 224px;
            height: 73px;
          }
        }
        .receive-invite-header {
          height: 66px;
          width: 100%;
          display: flex;
          justify-content: center;
          font-weight: 500;
          font-size: 16px;
          align-items: center;
          line-height: 66px;
          text-align: center;
          color: #000831;
          img {
            font-style: normal;
            width: 20px;
            height: 20px;
          }
          p {
            margin: 0 16px; 
          }
        }
        .receive-invite-img {
          width: 100%;
          display: flex;
          justify-content: center;
          img {
            width: 209px;
            height: 140px;
          }
        }
      }
      .invite-rule {
        height: 100px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        background: none;
        line-height: 100px;
        text-align: center;
        color: #F9F9F9;
        .auto-invite-btn {
          display: none;
        }
        p {
          cursor: pointer;
          line-height: 70px;
        }
        .invite-btn {
          width: 226px;
          height: 64px;
          background: #FDF300;
          border: 4px solid #0156FB;
          box-sizing: border-box;
          border-radius: 32px;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 58px;
          text-align: center;
          color: #0156FB;
          cursor: pointer;
          margin: 25px auto 0 auto;
        }
      }
    }

  }
  .invite-share-dialog {
    .share-avatar {
      width: 98px;
      height: 98px;
      position: absolute;
      left: 123px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: -45px;
      border-radius: 100%;
      background: white;
      img {
        width: 90px;
        height: 90px;
        border-radius: 100%;
        
      }
    }
    .share-title {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 21px;
      text-align: center;
      color: #333333;
    }
    .share-url {
      width: 100%;
      height: 50px;
      border: 1PX solid #627CFF;
      border-radius: 50px;
      margin: 31px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 15px;
      padding-right: 5px;
      .share-url-text {
        font-style: normal;
        font-weight: normal;
        font-size: 12.5px;
        line-height: 50px;
        color: #333333;
        width: 176px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }
      .share-url-btn {
        width: 90px;
        height: 40px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 40px;
        background: #627CFF;
        text-align: center;
        color: #FFFFFF;
        border-radius: 50px;
        cursor: pointer;
      }
    }
    .share-text {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      border-top: 1PX dashed #DDDDDD;
      line-height: 15px;
      color: #666666;
      span {
        width: 6px;
        height: 6px;
        background: #666666;
        border-radius: 100%;
        margin-right: 5px;
        flex-shrink: 0;
        position: relative;
        top: 5px;
      }
      &>div {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
      }
      &>p{
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        height: 58px;
        line-height: 65px;
        text-align: center;
        width: 100%;
        color: #333333;
      }
    }
    .close-btn {
      margin: 0 auto;
      width: 44px;
      height: 44px;
      cursor: pointer;
      position: absolute;
      bottom: -84px;
      left: 146px;
      border-radius: 50%;
      border: 2px solid #fff;
      @include flex;
      .close-icon {
        color: #fff;
        font-size: 20px;
      }
    }
  }
  .invite-rules-dialog, .order-rules-dialog{
    .rules-title{
      height: 40px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: #171717;
    }
    .rules-detail {
      height: 400px;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 17px;
        color: #666666;
        margin-bottom: 10px;
      }
      .bottom-title {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
      }
      .attention-title {
        margin-top: 40px;
      }
   
    }
    .close-btn {
      margin: 0 auto;
      width: 44px;
      height: 44px;
      cursor: pointer;
      position: absolute;
      bottom: -84px;
      left: 146px;
      border-radius: 50%;
      border: 2px solid #fff;
      @include flex;
      .close-icon {
        color: #fff;
        font-size: 20px;
      }
    }
  }
  .order-rules-dialog {
    .rules-detail {
      height: 100px;
    }
    .i-know-btn {
      width: 200px;
      height: 44px;
      background: #627CFF;
      border-radius: 22px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      margin: 0 auto;
      line-height: 44px;
      text-align: center;
      color: #FFFFFF;
    }
  }
  .order-rules-dialog-auto {
    display: none;
  }
  @media screen and (max-width: 599px){

    .invite-page-wrap {
      height: 2050px;
      .rules-auto {
        display: unset !important;
      }
      .rules-web {
        display: none !important;
      }
      .invite-top {
        height: 590px;
        background: url('~@/assets/images/auto-back-5.png') no-repeat top center;
        background-size:100% 362px;
        position: relative;
        top: 32px;
        // height: 
        display: flex;
        .invite-btn {
          width: 226px;
          height: 64px;
          top: 308px;
          left: 100px;
          position: absolute;
          background: #FDF300;
          border: 4px solid #0156FB;
          box-sizing: border-box;
          border-radius: 32px;
          font-style: normal;
          font-weight: 500;
          font-size: 20px;
          line-height: 58px;
          text-align: center;
          color: #0156FB;
          cursor: pointer;
        }
        .invite-btn {
          width: 303px;
          left: 50%;
          transform: translate(-50%);
          z-index: 1;
        }
        .invite-side {
          top: 6px !important;
          .my-invited {
            width: 90vw;
          }
        }
      }
  
      .invite-bottom {
        width: auto;
        height: 900px;
        &>div {
          width: 343px;
        }
        .invite-btn {
          display: none;
        }
        .image-text-1 {
          display: none;
        }
        .image-text-2 {
          display: none;
        }
        .my-reward {
          .myreward-header {
            display: flex;
            justify-content: space-between;
            padding: 0 17px;
            .myreward-header-right-auto {
              display: inline-block;
            }
            .myreward-header-right-normal {
              display: none;
            }
          }
          .myreward-content {
            padding: 0 17px;
            .myreward-content-invited {
              margin-right: 30px;
            }
            .myreward-content-count {
              margin-left: 30px;
            }
            .myreward-content-order {
              width: 122px;
            }
          }
        }
        .base-reward {
          .base-reward-bottom {
            >div {
              margin: 0 10px;  
            }
          }
          .more-reward-bottom {
            padding-left: 21px;
            .point-right {
              width: 18px;
              height: 18px;
              margin: 15px 19px 0 19px;
            }
          }
        }
        .invite-rule {
          .auto-invite-btn {
            display: block;
            width: 303px;
            margin: 0 auto;
            background: #FDF300;
            border: 4px solid #0156FB;
            box-sizing: border-box;
            border-radius: 32px;
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 58px;
            text-align: center;
            color: #0156FB;
            cursor: pointer;
          }
          .invite-btn {
            display: none;
          }
          p {
            height: 60px;
            line-height: 60px;
          }
        }
      }
      .invited-web {
        display: none;
      }
      .invited-auto {
        display: unset !important;
      }
      .reward-web {
        display: none;
      }
      .reward-auto {
        display: unset !important;
      }
    }
    .order-rules-dialog-auto {
      display: block;
    }
    .invited-content {
      -webkit-overflow-scrolling: touch;
    }
  }
  @media screen and (min-width: 600px) {
    .invite-page-wrap {
      background: #627CFF url('./images/referral-bc.png') no-repeat right 70px / 775px;
      .invite-top {
        .invite-btn {
          display: none;
        }
      }
    }
  }
</style>
